import React, { useState, useEffect } from "react";
import AWS from "aws-sdk";

import {
  deleteUserAttributes,
  updateUserAttributes
} from "components/shared/mailchimp";
import Alert from "components/shared/common/alert";
import emptyImg from "assets/images/account/empty-image.png";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: "us-east-1"
});

const s3 = new AWS.S3();

const MyAvatar = ({ profileImg, handleIsLoading, handleSetCurrentUser }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const deleteUserImg = async (isLoading = true) => {
    isLoading && handleIsLoading(true);
    let decodedUrl = decodeURIComponent(profileImg);
    let formattedString = decodedUrl.substring(decodedUrl.lastIndexOf("/") + 1);

    const params = {
      Bucket: "gameapart-assets",
      Key: "photos/" + formattedString
    };
    s3.deleteObject(params, async (err, data) => {
      if (err) {
        isLoading && handleIsLoading(false);
      } else {
        await deleteUserAttributes(
          ["custom:profile_picture"],
          async (res, err) => {
            if (res === "SUCCESS" && isLoading) {
              handleSetCurrentUser("picture", null);
            }
            isLoading && handleIsLoading(false);
          }
        );
        Alert("File deleted successfully.");
      }
    });
  };

  const deleteProfileImage = async () => {
    if (!profileImg || profileImg === "profileImage") return;
    await deleteUserImg(false);
  };

  useEffect(() => {
    if (!selectedFile) return;

    const uploadProfileImage = async () => {
      try {
        handleIsLoading(true);
        await deleteProfileImage();
        const params = {
          Bucket: "gameapart-assets",
          Key: "photos/" + selectedFile.name,
          Body: selectedFile,
          ACL: "public-read"
        };

        const uploadToS3 = () => {
          return new Promise((resolve, reject) => {
            s3.upload(params, (err, data) => {
              if (err) {
                reject(err);
              } else {
                resolve(data);
              }
            });
          });
        };

        const data = await uploadToS3();
        await updateUserAttributes(
          { "custom:profile_picture": data.Location },
          async (res, err) => {
            if (res === "SUCCESS")
              handleSetCurrentUser("picture", data.Location);
          }
        );
      } catch (error) {
        if (
          error.code === "InvalidAccessKeyId" ||
          error.code === "SignatureDoesNotMatch"
        ) {
          Alert(
            400,
            "The provided AWS Access Key or Secret Access Key is incorrect. Please contact support."
          );
        } else {
          Alert(400, "Error uploading profile image. Please try again.");
        }
      } finally {
        handleIsLoading(false);
      }
    };

    uploadProfileImage();
  }, [selectedFile]);

  return (
    <div className="my-image">
      <div className="my-image__flex">
        <div className="content">
          <h4 className="name">My Image</h4>
          <p className="desc">
            Manage the avatar your
            <br /> teammates will see while
            <br /> interacting with you.
          </p>
        </div>
        <div className="image">
          <div className="no-image">
            {profileImg && profileImg !== "profileImage" ? (
              <img
                alt="person"
                src={profileImg}
                className="img-fluid person-img"
              />
            ) : (
              <>
                <img alt="" src={emptyImg} />
                <span>No Image</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div>
        <div className="file-upload">
          <input
            type="file"
            id="file-input"
            name="file-input"
            className="upload"
            accept="image/*"
            onChange={(event) => setSelectedFile(event.target.files[0])}
          />
          <label htmlFor="file-input" id="file-input-label">
            Upload Image
          </label>
        </div>
        <button
          className="delete-btn"
          disabled={!profileImg || profileImg === "profileImage"}
          onClick={deleteUserImg}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default MyAvatar;
